export const FIND_FILE_REQUEST = 'FIND_FILE_REQUEST';

export const findFileRequest = ( guid ) => ({
    type: FIND_FILE_REQUEST,
    payload: { guid }
});
